/**
 * liveVideoStore
 */
import Vue from 'vue';
import * as types from '../mutation-types';
import * as urls from '../../config/urls';
import * as helpers from '../../utils/helpers';
import auth from '../../utils/auth';

const LIVEURL = 'LIVEURL';

export default {
    namespaced: true,
    state: {
        // liveVideo
        liveVideoList: [],
        liveVideoLoading: false,
        liveVideoExtra: 0,
        liveVideoQueries: { pagination: 1, pageSize: 6 },
        liveUrl: '',
    },
    mutations: {
        [types.UPDATE_LIST](state, { subject, list }) {
            state[`${subject}List`] = list;
        },
        [types.UPDATE_LOADING_STATUS](state, { subject, isLoading }) {
            state[`${subject}Loading`] = isLoading;
        },
        [types.UPDATE_EXTRA_INFO](state, { subject, extra }) {
            state[`${subject}Extra`] = extra;
        },
        [LIVEURL](state, { url }) {
            state.liveUrl = url;
        },
    },

    actions: {
        // liveVideo: 获取直播列表
        getliveVideoList({ commit, state }, queries = {}) {
            const subject = 'liveVideo';
            const {
                pagination = state[`${subject}Queries`].pagination,
                    pageSize = state[`${subject}Queries`].pageSize,
                    ...otherQueries
            } = queries;

            // const orgId = auth.getUserInfo().org_id || '';

            const urlUse = urls.GET_LIVE_LIST;
            return new Promise((resolve, reject) => {
                Vue.http.get(urlUse, {
                    params: {
                        pageNumber: pageSize,
                        offset: (pagination - 1) * pageSize,
                        ...otherQueries,
                    },
                }).then((response) => {
                    const list = response.data.row || {};
                    commit(types.UPDATE_LIST, { subject, list });
                    const { total } = response.data;
                    commit(types.UPDATE_EXTRA_INFO, { subject, extra: total });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        getLiveUrl({ commit }, { meetingId }) {
            const { port } = document.location;
            let hostUrl = 'http://';

            if (port === 80) {
                hostUrl += document.location.hostname;
            } else {
                hostUrl += document.location.host;
            }
            const url = `${hostUrl}/media?cmd=get_live_address&meetingid=${meetingId}`;

            console.log(url);
            return new Promise((resolve2, reject2) => {
                // const urlv = helpers.buildURL(URL1, param.action, param.params);
                Vue.http.get(url).then((response2) => {
                    const liveUrl = response2 || '';

                    commit(LIVEURL, { liveUrl });
                    resolve2(response2);
                }).catch((error) => {
                    reject2(error);
                });
            });
        },

        addMeetingView(_, formData = {}) {
            let urlUse = urls.MEETINGVIEW;
            console.log(urlUse);
            const data = helpers.pick(formData, [
                'meeting_id',
                'view'
            ]);


            urlUse = `${urlUse}&meeting_id=${data.meeting_id}&view=${data.view}`;

            return new Promise((resolve, reject) => {
                Vue.http.get(urlUse, {}).then((response) => {
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },
        getMeetingView(_, formData = {}) {
            let urlUse = urls.VIEWCOUNT;
            // console.log(urlUse);
            const data = helpers.pick(formData, [
                'meeting_id',

            ]);


            urlUse = `${urlUse}&meeting_id=${data.meeting_id}`;

            return new Promise((resolve, reject) => {
                Vue.http.get(urlUse, {}).then((response) => {
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

    },
};